import { render, staticRenderFns } from "./DataManagePackages.vue?vue&type=template&id=1b565d2e&scoped=true"
import script from "./DataManagePackages.vue?vue&type=script&lang=js"
export * from "./DataManagePackages.vue?vue&type=script&lang=js"
import style0 from "./DataManagePackages.vue?vue&type=style&index=0&id=1b565d2e&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b565d2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1b565d2e')) {
      api.createRecord('1b565d2e', component.options)
    } else {
      api.reload('1b565d2e', component.options)
    }
    module.hot.accept("./DataManagePackages.vue?vue&type=template&id=1b565d2e&scoped=true", function () {
      api.rerender('1b565d2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/managePackages/components/DataManagePackages.vue"
export default component.exports